export const business = {
  extends: 'Page',
  flow: 'y',
  background: 'white',
  color: 'inkText',

  NavBar: {},

  HeroSection: {
    tag: 'section',
    flow: 'y',
    align: 'center center',
    textAlign: 'center',
    width: '100%',
    padding: 'G B E B',
    backgroundSize: 'cover',
    backgroundPosition: 'bottom',
    backgroundImage: 'https://images.unsplash.com/photo-1738293728393-c72504a0f72d?q=80&w=2734&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    '@mobileL': { padding: 'F A D A' },
    position: 'relative',

    ':before': {
      content: '""',
      position: 'absolute',
      top: '0', left: '0', width: '100%', height: '100%',
      background: 'white.65',
      zIndex: '0'
    },

    HeroContent: {
      tag: 'hgroup',
      flow: 'y',
      gap: 'A',
      position: 'relative',
      zIndex: '1',

      HeroBadge: {
        tag: 'span',
        text: '{{ businessHeroBadge | polyglot }}',
        fontSize: 'Z',
        fontWeight: '600',
        color: 'teal',
        textTransform: 'uppercase',
        letterSpacing: 'Y',
        background: 'tealLight',
        padding: 'Y Z',
        round: 'D',
        alignSelf: 'center'
      },
      HeroTitle: {
        tag: 'h1',
        text: '{{ businessHeroTitle | polyglot }}',
        fontSize: 'G',
        fontWeight: '800',
        letterSpacing: '-0.05em',
        lineHeight: '1.0',
        color: 'inkText',
        '@mobileL': { fontSize: 'E' }
      },
      HeroSubtitle: {
        tag: 'h2',
        text: '{{ businessHeroSubtitle | polyglot }}',
        fontSize: 'B',
        fontWeight: '400',
        color: 'inkMuted',
        maxWidth: 'J',
        lineHeight: '1.6',
        marginTop: 'Z',
        '@mobileL': { fontSize: 'A' }
      },
      HeroActions: {
        flow: 'x',
        gap: 'Z',
        marginTop: 'B',
        align: 'center center',
        '@mobileL': { flow: 'y', width: '100%' },
        DemoBtn: {
          extends: 'Link',
          href: '/dashboard',
          text: '{{ tryDemo | polyglot }}',
          background: 'teal',
          color: 'white',
          fontWeight: '600',
          padding: 'Z1 B',
          round: 'B',
          fontSize: 'A',
          textDecoration: 'none',
          transition: 'all 0.2s ease',
          ':hover': { opacity: '0.9' }
        },
        PitchBtn: {
          extends: 'Link',
          href: '/pitch',
          text: '{{ viewPitch | polyglot }}',
          background: 'inkSurface',
          color: 'inkText',
          fontWeight: '600',
          padding: 'Z1 B',
          round: 'B',
          fontSize: 'A',
          textDecoration: 'none',
          border: '1px solid inkBorder',
          transition: 'all 0.2s ease',
          ':hover': { background: 'inkBorder' }
        }
      }
    }
  },

  ProblemsSection: {
    tag: 'section',
    flow: 'y',
    gap: 'B',
    padding: 'E B',
    width: '100%',
    maxWidth: 'K',
    margin: '0 auto',
    '@mobileL': { padding: 'D A' },
    ProblemTitle: { tag: 'h2', text: '{{ theProblem | polyglot }}', fontSize: 'D', fontWeight: '700', letterSpacing: '-0.03em', textAlign: 'center', marginBottom: 'Z', color: 'inkText' },
    ProblemSubtitle: { text: '{{ problemSubtitle | polyglot }}', fontSize: 'B', fontWeight: '400', color: 'inkMuted', textAlign: 'center', marginBottom: 'C', lineHeight: '1.5' },
    ProblemCards: {
      display: 'grid',
      gridTemplateColumns: 'repeat(4, 1fr)',
      gap: 'A',
      '@tabletS': { gridTemplateColumns: 'repeat(2, 1fr)' },
      '@mobileL': { gridTemplateColumns: '1fr' },
      children: [
        { icon: 'barChart', title: 'Excel & WhatsApp Chaos', detail: 'Clinics manage appointments through spreadsheets and chat groups. Zero automation, constant errors, lost records.' },
        { icon: 'bell', title: '25% No-Show Rate', detail: 'Without automated reminders, patients forget appointments. Empty chairs mean \u20BE500+/day in lost revenue.' },
        { icon: 'file', title: 'Paper Charts in 2026', detail: 'Handwritten clinical notes, no digital odontogram, no perio tracking. Critical data trapped in filing cabinets.' },
        { icon: 'dollarSign', title: 'Insurance Black Hole', detail: 'Manual claims to Aldagi, GPI, Imedi L take hours. Denied claims pile up with no tracking or appeal workflow.' }
      ],
      childrenAs: 'state',
      childExtends: 'PainPointCard'
    }
  },

  PlatformSection: {
    tag: 'section',
    flow: 'y',
    gap: 'B',
    padding: 'E B',
    width: '100%',
    maxWidth: 'K',
    margin: '0 auto',
    attr: { id: 'features' },
    '@mobileL': { padding: 'D A' },
    PlatformTitle: { tag: 'h2', text: '{{ oneplatform | polyglot }}', fontSize: 'D', fontWeight: '700', letterSpacing: '-0.03em', textAlign: 'center', marginBottom: 'Z', color: 'inkText' },
    PlatformSubtitle: { text: '{{ platformSubtitle | polyglot }}', fontSize: 'B', fontWeight: '400', color: 'inkMuted', textAlign: 'center', marginBottom: 'C', lineHeight: '1.5' },

    ClinicalModules: {
      flow: 'y', gap: 'A', marginBottom: 'C',
      ClinicalLabel: { text: '{{ clinical | polyglot }}', fontSize: 'Y', fontWeight: '700', color: 'teal', letterSpacing: 'Y', textTransform: 'uppercase', marginBottom: 'Z' },
      ClinicalGrid: {
        display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 'A',
        '@tabletS': { gridTemplateColumns: 'repeat(2, 1fr)' },
        '@mobileL': { gridTemplateColumns: '1fr' },
        children: [
          { icon: 'tooth', title: 'Digital Odontogram', detail: 'FDI 32-tooth chart with 5-surface tracking. Click any surface to record caries, restorations, crowns, implants, and missing teeth.' },
          { icon: 'activity', title: 'Perio Charting', detail: '192-site periodontal grid. 6-point probing, BOP, CAL, furcation, mobility. AAP staging via Gemini AI.' },
          { icon: 'clipboard', title: 'Treatment Planning', detail: 'Phased plans with CDT codes, insurance estimates, patient portions. Drag-and-drop reordering. AI sequencing.' },
          { icon: 'file', title: 'SOAP Notes + AI Scribe', detail: 'Structured clinical documentation with templates. Gemini generates notes from voice or chart data.' }
        ],
        childrenAs: 'state',
        childExtends: 'FeatureCard'
      }
    },

    OpsModules: {
      flow: 'y', gap: 'A', marginBottom: 'C',
      OpsLabel: { text: '{{ operations | polyglot }}', fontSize: 'Y', fontWeight: '700', color: 'amber', letterSpacing: 'Y', textTransform: 'uppercase', marginBottom: 'Z' },
      OpsGrid: {
        display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 'A',
        '@tabletS': { gridTemplateColumns: 'repeat(2, 1fr)' },
        '@mobileL': { gridTemplateColumns: '1fr' },
        children: [
          { icon: 'calendar', title: 'Multi-Chair Scheduling', detail: 'Week view with multiple operatories. Provider color-coding, production goals, waitlist management.' },
          { icon: 'dollarSign', title: 'Billing & Insurance', detail: 'Claims tracking for Aldagi, GPI, Imedi L. Patient ledger, aging buckets, payment plans, eligibility checks.' },
          { icon: 'rx', title: 'e-Prescribing', detail: 'Digital prescriptions with templates. Gemini-powered drug interaction checking. Georgian pharmacy integration.' },
          { icon: 'flask', title: 'Lab Case Tracking', detail: 'Kanban pipeline: Ordered \u2192 Fabrication \u2192 Shipped \u2192 Received. Vendor management, quality tracking.' }
        ],
        childrenAs: 'state',
        childExtends: 'FeatureCard'
      }
    },

    MoreModules: {
      flow: 'y', gap: 'A',
      MoreLabel: { text: '{{ analyticsEnterprise | polyglot }}', fontSize: 'Y', fontWeight: '700', color: 'purple', letterSpacing: 'Y', textTransform: 'uppercase', marginBottom: 'Z' },
      MoreGrid: {
        display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 'A',
        '@tabletS': { gridTemplateColumns: 'repeat(2, 1fr)' },
        '@mobileL': { gridTemplateColumns: '1fr' },
        children: [
          { icon: 'barChart', title: 'Production Reports', detail: 'Gross/net production, collection rates, treatment acceptance, recall effectiveness. Per-provider breakdown.' },
          { icon: 'send', title: 'Referral Management', detail: 'Inbound/outbound referrals to specialists. AI-generated referral letters. Status tracking.' },
          { icon: 'pulse', title: 'Medical History', detail: '11-view patient record: timeline, conditions (ICD-10), medications, allergies, vitals, imaging, documents.' },
          { icon: 'shield', title: 'Enterprise Admin', detail: 'RBAC, audit logs, compliance meters, multi-tenancy, SSO, feature flags, API management.' }
        ],
        childrenAs: 'state',
        childExtends: 'FeatureCard'
      }
    }
  },

  AiSection: {
    tag: 'section',
    flow: 'y',
    gap: 'B',
    padding: 'E B',
    width: '100%',
    background: 'inkMid',
    attr: { id: 'ai' },
    '@mobileL': { padding: 'D A' },

    AiInner: {
      flow: 'y', gap: 'B', maxWidth: 'K', margin: '0 auto', width: '100%',
      AiTitle: { tag: 'h2', text: '{{ geminiBuiltIn | polyglot }}', fontSize: 'D', fontWeight: '700', letterSpacing: '-0.03em', textAlign: 'center', marginBottom: 'Y', color: 'inkText' },
      AiSubtitle: { text: '{{ geminiSubtitle | polyglot }}', fontSize: 'A', color: 'purple', textAlign: 'center', marginBottom: 'C', fontWeight: '500' },

      AiCards: {
        display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 'A',
        '@tabletS': { gridTemplateColumns: 'repeat(2, 1fr)' },
        '@mobileL': { gridTemplateColumns: '1fr' },

        XrayAiCard: {
          flow: 'y', gap: 'A', padding: 'B', round: 'A', background: 'white', border: '1px solid purple.2',
          transition: 'all 0.3s ease', ':hover': { borderColor: 'purple' },
          CardIcon1: { extends: 'Icon', icon: 'xray', width: 'B', height: 'B', color: 'purple' },
          CardTitle1: { text: '{{ xrayAnalysis2 | polyglot }}', fontSize: 'A', fontWeight: '700', color: 'inkText' },
          CardDetail1: { text: '{{ uploadDentalRadiographsFor | polyglot }}', fontSize: 'Z', color: 'inkMuted', lineHeight: '1.7' }
        },
        PerioAiCard: {
          flow: 'y', gap: 'A', padding: 'B', round: 'A', background: 'white', border: '1px solid purple.2',
          transition: 'all 0.3s ease', ':hover': { borderColor: 'purple' },
          CardIcon2: { extends: 'Icon', icon: 'activity', width: 'B', height: 'B', color: 'purple' },
          CardTitle2: { text: '{{ perioAssessment2 | polyglot }}', fontSize: 'A', fontWeight: '700', color: 'inkText' },
          CardDetail2: { text: '{{ automaticAapStaginggradingFrom | polyglot }}', fontSize: 'Z', color: 'inkMuted', lineHeight: '1.7' }
        },
        ScribeAiCard: {
          flow: 'y', gap: 'A', padding: 'B', round: 'A', background: 'white', border: '1px solid purple.2',
          transition: 'all 0.3s ease', ':hover': { borderColor: 'purple' },
          CardIcon3: { extends: 'Icon', icon: 'clipboard', width: 'B', height: 'B', color: 'purple' },
          CardTitle3: { text: '{{ clinicalScribe2 | polyglot }}', fontSize: 'A', fontWeight: '700', color: 'inkText' },
          CardDetail3: { text: '{{ generatesSoapNotesFrom | polyglot }}', fontSize: 'Z', color: 'inkMuted', lineHeight: '1.7' }
        },
        RiskAiCard: {
          flow: 'y', gap: 'A', padding: 'B', round: 'A', background: 'white', border: '1px solid purple.2',
          transition: 'all 0.3s ease', ':hover': { borderColor: 'purple' },
          CardIcon4: { extends: 'Icon', icon: 'shield', width: 'B', height: 'B', color: 'purple' },
          CardTitle4: { text: '{{ riskProfiling2 | polyglot }}', fontSize: 'A', fontWeight: '700', color: 'inkText' },
          CardDetail4: { text: '{{ analyzesConditionsFamilyHistor | polyglot }}', fontSize: 'Z', color: 'inkMuted', lineHeight: '1.7' }
        },
        TxAiCard: {
          flow: 'y', gap: 'A', padding: 'B', round: 'A', background: 'white', border: '1px solid purple.2',
          transition: 'all 0.3s ease', ':hover': { borderColor: 'purple' },
          CardIcon5: { extends: 'Icon', icon: 'sparkle', width: 'B', height: 'B', color: 'purple' },
          CardTitle5: { text: '{{ treatmentSequencing2 | polyglot }}', fontSize: 'A', fontWeight: '700', color: 'inkText' },
          CardDetail5: { text: '{{ aioptimizedTreatmentPhasingCon | polyglot }}', fontSize: 'Z', color: 'inkMuted', lineHeight: '1.7' }
        },
        CommAiCard: {
          flow: 'y', gap: 'A', padding: 'B', round: 'A', background: 'white', border: '1px solid purple.2',
          transition: 'all 0.3s ease', ':hover': { borderColor: 'purple' },
          CardIcon6: { extends: 'Icon', icon: 'globe', width: 'B', height: 'B', color: 'purple' },
          CardTitle6: { text: '{{ patientCommunication2 | polyglot }}', fontSize: 'A', fontWeight: '700', color: 'inkText' },
          CardDetail6: { text: '{{ generatesPatientfriendlyExplan | polyglot }}', fontSize: 'Z', color: 'inkMuted', lineHeight: '1.7' }
        }
      }
    }
  },

  IntegrationsSection: {
    tag: 'section',
    flow: 'y',
    gap: 'B',
    padding: 'E B',
    width: '100%',
    maxWidth: 'K',
    margin: '0 auto',
    '@mobileL': { padding: 'D A' },

    IntTitle: { tag: 'h2', text: '{{ georgianEcosystem | polyglot }}', fontSize: 'D', fontWeight: '700', letterSpacing: '-0.03em', textAlign: 'center', marginBottom: 'Z', color: 'inkText' },
    IntSubtitle: { text: '{{ integrationsSubtitle | polyglot }}', fontSize: 'B', fontWeight: '400', color: 'inkMuted', textAlign: 'center', marginBottom: 'C', lineHeight: '1.5' },

    IntGrid: {
      display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 'A',
      '@tabletS': { gridTemplateColumns: 'repeat(2, 1fr)' },
      '@mobileL': { gridTemplateColumns: '1fr' },

      InsuranceCard: {
        flow: 'y', gap: 'Z', padding: 'B', round: 'A', background: 'inkMid', border: '1px solid inkBorder',
        InsLabel: { text: '{{ insurance2 | polyglot }}', fontSize: 'Y', fontWeight: '700', color: 'teal', letterSpacing: 'X', textTransform: 'uppercase' },
        InsNames: { text: 'Aldagi  \u00B7  GPI  \u00B7  Imedi L  \u00B7  Unison', fontSize: 'Z', color: 'inkText', fontWeight: '500', lineHeight: '1.6' },
        InsDetail: { text: '{{ automatedClaimsEligibilityVeri | polyglot }}', fontSize: 'Y', color: 'inkMuted', lineHeight: '1.5' }
      },
      PaymentsCard: {
        flow: 'y', gap: 'Z', padding: 'B', round: 'A', background: 'inkMid', border: '1px solid inkBorder',
        PayLabel: { text: '{{ payments2 | polyglot }}', fontSize: 'Y', fontWeight: '700', color: 'teal', letterSpacing: 'X', textTransform: 'uppercase' },
        PayNames: { text: 'TBC Pay  \u00B7  BOG iPay  \u00B7  Stripe', fontSize: 'Z', color: 'inkText', fontWeight: '500', lineHeight: '1.6' },
        PayDetail: { text: '{{ onlinePaymentsPaymentPlans | polyglot }}', fontSize: 'Y', color: 'inkMuted', lineHeight: '1.5' }
      },
      MessagingCard: {
        flow: 'y', gap: 'Z', padding: 'B', round: 'A', background: 'inkMid', border: '1px solid inkBorder',
        MsgLabel: { text: '{{ messaging2 | polyglot }}', fontSize: 'Y', fontWeight: '700', color: 'teal', letterSpacing: 'X', textTransform: 'uppercase' },
        MsgNames: { text: 'WhatsApp  \u00B7  SMS.ge  \u00B7  Email', fontSize: 'Z', color: 'inkText', fontWeight: '500', lineHeight: '1.6' },
        MsgDetail: { text: '{{ appointmentRemindersRecallCamp | polyglot }}', fontSize: 'Y', color: 'inkMuted', lineHeight: '1.5' }
      },
      EhrCard: {
        flow: 'y', gap: 'Z', padding: 'B', round: 'A', background: 'inkMid', border: '1px solid inkBorder',
        EhrLabel: { text: '{{ ehrLabs2 | polyglot }}', fontSize: 'Y', fontWeight: '700', color: 'teal', letterSpacing: 'X', textTransform: 'uppercase' },
        EhrNames: { text: 'FHIR R4  \u00B7  HL7v2  \u00B7  DICOM', fontSize: 'Z', color: 'inkText', fontWeight: '500', lineHeight: '1.6' },
        EhrDetail: { text: '{{ interoperableHealthRecordsLab | polyglot }}', fontSize: 'Y', color: 'inkMuted', lineHeight: '1.5' }
      }
    }
  },

  StatsSection: {
    tag: 'section',
    flow: 'x',
    align: 'center center',
    gap: 'D',
    padding: 'D B',
    width: '100%',
    maxWidth: 'K',
    margin: '0 auto',
    flexWrap: 'wrap',
    '@mobileL': { display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 'B', padding: 'C A' },

    StatClinics: { flow: 'y', align: 'center center', gap: 'Y',
      StatNum1: { text: '212+', fontSize: 'D', fontWeight: '800', color: 'inkText', letterSpacing: '-0.02em' },
      StatLabel1: { text: '{{ clinicsInDatabase | polyglot }}', fontSize: 'Y', color: 'inkMuted', textTransform: 'uppercase', letterSpacing: 'X', fontWeight: '500' }
    },
    StatModules: { flow: 'y', align: 'center center', gap: 'Y',
      StatNum2: { text: '15', fontSize: 'D', fontWeight: '800', color: 'inkText', letterSpacing: '-0.02em' },
      StatLabel2: { text: '{{ platformModules2 | polyglot }}', fontSize: 'Y', color: 'inkMuted', textTransform: 'uppercase', letterSpacing: 'X', fontWeight: '500' }
    },
    StatAi: { flow: 'y', align: 'center center', gap: 'Y',
      StatNum3: { text: '6', fontSize: 'D', fontWeight: '800', color: 'inkText', letterSpacing: '-0.02em' },
      StatLabel3: { text: 'AI Tools (Gemini)', fontSize: 'Y', color: 'inkMuted', textTransform: 'uppercase', letterSpacing: 'X', fontWeight: '500' }
    },
    StatIntegrations: { flow: 'y', align: 'center center', gap: 'Y',
      StatNum4: { text: '20+', fontSize: 'D', fontWeight: '800', color: 'inkText', letterSpacing: '-0.02em' },
      StatLabel4: { text: '{{ integrations2 | polyglot }}', fontSize: 'Y', color: 'inkMuted', textTransform: 'uppercase', letterSpacing: 'X', fontWeight: '500' }
    }
  },

  PricingSection: {
    tag: 'section',
    flow: 'y',
    gap: 'B',
    padding: 'E B',
    width: '100%',
    maxWidth: 'K',
    margin: '0 auto',
    attr: { id: 'pricing' },
    '@mobileL': { padding: 'D A' },
    PricingTitle: { tag: 'h2', text: '{{ pricingTitle | polyglot }}', fontSize: 'D', fontWeight: '700', letterSpacing: '-0.03em', textAlign: 'center', marginBottom: 'Z', color: 'inkText' },
    PricingSubtitle: { text: '{{ pricingSubtitle | polyglot }}', fontSize: 'B', fontWeight: '400', color: 'inkMuted', textAlign: 'center', marginBottom: 'C', lineHeight: '1.5' },
    PricingRow: {
      flow: 'x', gap: 'A', flexWrap: 'wrap',
      '@mobileL': { flow: 'y' },
      children: [
        { tier: 'Starter', amount: '\u20BE0', period: '/month', description: '1 dentist, basic charting, 50 patients, booking widget. No credit card required.', highlighted: false },
        { tier: 'Growth', amount: '\u20BE79', period: '/month', description: '3 providers, full odontogram + perio, scheduling, SMS reminders, basic billing, AI notes.', highlighted: false },
        { tier: 'Professional', amount: '\u20BE199', period: '/month', description: 'Unlimited providers, all 15 modules, insurance integration (Aldagi/GPI), e-prescribing, lab tracking, full AI suite.', highlighted: true },
        { tier: 'Enterprise', amount: '\u20BE399+', period: '/month', description: 'Multi-location, RBAC, audit logs, SSO, custom integrations, dedicated account manager, 99.9% SLA.', highlighted: false }
      ],
      childrenAs: 'state',
      childExtends: 'PricingCard'
    }
  },

  TestimonialsSection: {
    tag: 'section',
    flow: 'y',
    gap: 'B',
    padding: 'E B',
    width: '100%',
    maxWidth: 'K',
    margin: '0 auto',
    '@mobileL': { padding: 'D A' },
    TestimonialsTitle: { tag: 'h2', text: '{{ trustedBy | polyglot }}', fontSize: 'D', fontWeight: '700', letterSpacing: '-0.03em', textAlign: 'center', marginBottom: 'C', color: 'inkText' },
    TestimonialCards: {
      flow: 'x', gap: 'A', flexWrap: 'wrap',
      '@mobileL': { flow: 'y' },
      children: [
        { quote: 'We cut no-shows by 65% in the first month. The digital odontogram replaced our paper charts overnight \u2014 our hygienists love the perio module.', clinic: 'Denta Plus', location: 'Tbilisi \u00B7 5 Locations' },
        { quote: 'Insurance claim processing went from 3 hours/day to 15 minutes. Aldagi and GPI claims are now automated. The billing module alone justified the cost.', clinic: 'NB Dental', location: 'Tbilisi, Vake' },
        { quote: 'The AI clinical notes save our doctors 40 minutes per day. Gemini generates accurate SOAP notes from our charting data \u2014 in Georgian.', clinic: "Richter's Clinic", location: 'Tbilisi, Saburtalo' }
      ],
      childrenAs: 'state',
      childExtends: 'TestimonialCard'
    }
  },

  CtaSection: {
    tag: 'section',
    flow: 'y',
    align: 'center center',
    gap: 'A',
    padding: 'F B',
    width: '100%',
    textAlign: 'center',
    background: 'inkText',
    '@mobileL': { padding: 'E A' },

    CtaTitle: { tag: 'h2', text: '{{ readyModernize | polyglot }}', fontSize: 'D', fontWeight: '700', letterSpacing: '-0.03em', color: 'white' },
    CtaSubtitle: { text: '{{ joinCount | polyglot }}', fontSize: 'B', fontWeight: '400', color: 'white.6', marginBottom: 'A', lineHeight: '1.5' },
    CtaActions: {
      flow: 'x', gap: 'Z', align: 'center center',
      '@mobileL': { flow: 'y', width: '100%' },
      CtaDemoBtn: {
        extends: 'Link', href: '/dashboard', text: '{{ startTrial | polyglot }}',
        background: 'teal', color: 'white', fontWeight: '600', padding: 'Z1 B', round: 'B', fontSize: 'A', textDecoration: 'none',
        transition: 'all 0.2s ease', ':hover': { opacity: '0.9' }
      },
      CtaContactBtn: {
        extends: 'Link', href: 'mailto:hello@mcai.ge', text: '{{ contactSales | polyglot }}',
        background: 'transparent', color: 'white', fontWeight: '600', padding: 'Z1 B', round: 'B', fontSize: 'A', textDecoration: 'none',
        border: '1px solid white.3', transition: 'all 0.2s ease', ':hover': { background: 'white.1' }
      }
    },
    CtaNote: { text: '{{ noCreditCard | polyglot }}', fontSize: 'Y', color: 'white.4', marginTop: 'A' }
  },

  FooterSection: {
    tag: 'footer',
    flow: 'y',
    gap: 'Z',
    padding: 'B B',
    width: '100%',
    borderTop: '1px solid inkBorder',
    align: 'center center',
    FooterTop: {
      flow: 'x',
      align: 'center space-between',
      width: '100%',
      maxWidth: 'K',
      '@mobileL': { flow: 'y', gap: 'A', align: 'center center' },
      FooterLogo: { text: 'MCAI', fontSize: 'A', fontWeight: '700', color: 'inkText' },
      FooterLinks: {
        flow: 'x', gap: 'B',
        HomeLink: { extends: 'Link', text: '{{ home2 | polyglot }}', href: '/', color: 'inkMuted', fontSize: 'Z', textDecoration: 'none', fontWeight: '500', ':hover': { color: 'inkText' } },
        FeatLink: { extends: 'Link', text: '{{ features2 | polyglot }}', href: '/business#features', color: 'inkMuted', fontSize: 'Z', textDecoration: 'none', fontWeight: '500', ':hover': { color: 'inkText' } },
        PriceLink: { extends: 'Link', text: '{{ pricing2 | polyglot }}', href: '/business#pricing', color: 'inkMuted', fontSize: 'Z', textDecoration: 'none', fontWeight: '500', ':hover': { color: 'inkText' } },
        DashLink: { extends: 'Link', text: '{{ dashboard2 | polyglot }}', href: '/dashboard', color: 'inkMuted', fontSize: 'Z', textDecoration: 'none', fontWeight: '500', ':hover': { color: 'inkText' } }
      },
      FooterContact: { text: 'hello@mcai.ge', fontSize: 'Z', color: 'inkMuted' }
    },
    FooterCopy: { text: '{{ u00a92026McaiU2014 | polyglot }}', fontSize: 'Y', color: 'inkMuted', marginTop: 'Z' }
  }
}
